import { Container, SkeletonText } from "@chakra-ui/react";
import { useResource } from "hooks/useResource";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FormData } from "../forms/FormData";
import LayoutAgendaSteps from "./LayoutAgendaSteps";

export default function PageEditAgendaIdentify() {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const location = useLocation();
  const { data: agenda, isLoading } = useResource({
    id,
    resourceName: "agenda",
    path: "agendas",
  });

  if (agenda && agenda.email) navigate(`/disparos-de-agenda${location.search}`);

  return (
    <LayoutAgendaSteps isEditing>
      <Container
        variant="internal"
        flexDirection="column"
        mb="80px"
        minH="900px"
      >
        <SkeletonText isLoaded={!isLoading}>
          {agenda && <FormData agenda={agenda} isEditing />}
        </SkeletonText>
      </Container>
    </LayoutAgendaSteps>
  );
}
